var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"UserList"},[(!_vm.justlist)?_c('ListFilters',{attrs:{"totals":_vm.totals,"rolename":_vm.rolename},on:{"update":_vm.filterUpdate}}):_vm._e(),_vm._v(" "),_c('SortableTable',{attrs:{"columns":_vm.columns,"users":_vm.list},on:{"update":_vm.sortUpdate}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-75b0fa8f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/UserList.vue
// module id = null
// module chunks = 